<template lang='pug'>
.popup
  .popup-overlay(@click="closePopup")
  .popup-body
    div.popup-body--table
      .popup-headBody
        SectionTitle(sectionText="回報錯誤訊息" :subtitleText="'此查核結果共有' + totalElements + '則錯誤資訊回報'" displaySubtitleSection=true isSubtitleSectionOnPopup=true)
        .popup-iconClose
          i.icon-sidemenu-close(@click="closePopup")
      .popup-content
        .popup-listItem(v-for="(info, idx) in infos" :class="info.isNew ? 'popup-listItem--active' : ''")
          v-clamp.popup-titleList(autoresize :max-lines="8") {{ info.content }}
          .popup-subtitleList
            span.popup-subtitleItem {{ info.createdAtStr }}
            span.popup-subtitleItem {{ "類型：" + info.feedbackType[$store.state.lang] }}
    .popup-pagination
      Pagination(:pageCount='totalPages' @changePage='changePage')
</template>
<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import PopupButtonsOnBottom from '@/components/popup/popup-buttons-on-bottom.vue'
import Pagination from '@/components/modules/pagination/pagination.vue'
import { lockBody, unlockBody } from '@/plugins/tool.js'
import VClamp from 'vue-clamp'

export default {
  components: {
    SectionTitle,
    PopupButtonsOnBottom,
    Pagination,
    VClamp
  },
  props: {
    commentId: Number,
    infos: Array,
    totalPages: Number,
    totalElements: Number
  },
  mounted() {
    lockBody()
  },
  methods: {
    closePopup() {
      unlockBody()
      this.$emit("closePopup")
    },
    changePage(page) {
      this.$emit("changePage", page)
    },
  }
}
</script>
